var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseOutlineGlyph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2697 1.49533C12.1779 0.938097 11.7121 0.522526 11.1542 0.499983C10.5962 0.477441 10.0992 0.854115 9.96376 1.40216L5.47266 19.5759H1.67857C1.02766 19.5759 0.5 20.1098 0.5 20.7682C0.5 21.4267 1.02766 21.9606 1.67857 21.9606H6.39286C6.93367 21.9606 7.40507 21.5882 7.53624 21.0574L10.8762 7.54195L14.6589 30.5027C14.7495 31.0526 15.2046 31.4656 15.7548 31.4971C16.305 31.5286 16.8033 31.1703 16.9547 30.6342L20.6223 17.6477L21.7748 21.1453C21.9352 21.6322 22.3856 21.9606 22.8929 21.9606H26.6298C27.1151 23.3498 28.4248 24.3452 29.9643 24.3452C31.917 24.3452 33.5 22.7437 33.5 20.7682C33.5 18.7928 31.917 17.1913 29.9643 17.1913C28.4248 17.1913 27.1151 18.1867 26.6298 19.5759H23.7423L21.6538 13.2374C21.4904 12.7414 21.0267 12.411 20.5101 12.4224C19.9935 12.4337 19.5444 12.7842 19.4025 13.2869L16.1245 24.8936L12.2697 1.49533ZM28.7857 20.7682C28.7857 21.4267 29.3134 21.9606 29.9643 21.9606C30.6152 21.9606 31.1429 21.4267 31.1429 20.7682C31.1429 20.1098 30.6152 19.5759 29.9643 19.5759C29.3134 19.5759 28.7857 20.1098 28.7857 20.7682Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseOutlineGlyph);
export default __webpack_public_path__ + "static/media/pulse-outline-glyph.ceb7d03af83b5e9988b47210e341e34c.svg";
export { ForwardRef as ReactComponent };